module.exports = __webpack_public_path__ + "media/images/share-440e2ef817ecb7a03efaefb4c828095e.png";